import { useMutation } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { updateTagPhotoApi } from 'features/tags/services/taggings.service';

export const useUploadStaticDataPicture = (options: UseMutationOptions = {}) => {
  return useMutation(updateTagPhotoApi, options);
};
